import { render, staticRenderFns } from "./jieshao.vue?vue&type=template&id=f86eea16&scoped=true&"
import script from "./jieshao.vue?vue&type=script&lang=js&"
export * from "./jieshao.vue?vue&type=script&lang=js&"
import style0 from "./jieshao.vue?vue&type=style&index=0&id=f86eea16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86eea16",
  null
  
)

export default component.exports